import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { EnquiryForm } from "@/components/common/EnquiryForm";
import { Mail, MapPin, Building2 } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { PAGES, CONTACTS, IMAGES, SEO } from "@/content/site";

export default function Contact() {
  const p = PAGES.contact;
  return (
    <div data-testid="page-contact">
      <Seo title={SEO.contact.t} description={SEO.contact.d} path="/contact" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.officeDiscuss} />
      <section className="container-x py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="text-2xl font-semibold text-ink-heading">Get in touch</h2>
              <p className="mt-3 text-base leading-relaxed text-ink-body">
                Enquiries are routed to the right team automatically. You can also reach us directly:
              </p>
              <div className="mt-8 space-y-6">
                <div className="flex items-start gap-4">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-azeka-navy text-azeka-teal2"><Mail className="h-5 w-5" /></span>
                  <div>
                    <p className="text-sm font-semibold text-ink-heading">General enquiries</p>
                    <a href={`mailto:${CONTACTS.general}`} data-testid="contact-email-general" className="text-sm text-azeka-teal hover:underline">{CONTACTS.general}</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-azeka-navy text-azeka-teal2"><Building2 className="h-5 w-5" /></span>
                  <div>
                    <p className="text-sm font-semibold text-ink-heading">Trade, sourcing & suppliers</p>
                    <a href={`mailto:${CONTACTS.trade}`} data-testid="contact-email-trade" className="text-sm text-azeka-teal hover:underline">{CONTACTS.trade}</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-azeka-navy text-azeka-teal2"><MapPin className="h-5 w-5" /></span>
                  <div>
                    <p className="text-sm font-semibold text-ink-heading">Location</p>
                    <p className="text-sm text-ink-body">{CONTACTS.location}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="rounded-2xl border border-slate-200/80 bg-white p-8 lg:p-10">
              <EnquiryForm defaultType="general" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
